<template>
    <side-panel @close="close">
        <template #header>
            <h3  class="mt-0 clearfix">
                {{ $l10n.__("Service email") }}
            </h3>
        </template>

        <template #content class="prelative">
            <div id="onboarding">
                <h1 class="my-4">{{ $l10n.__("Bienvenue sur le service email") }}</h1>
                <email-onboarding-provider @validProvider="onValidProvider"></email-onboarding-provider>
            </div>
        </template>
        
    </side-panel>
</template>

<script>

import SidePanel from 'vcomponents/utilities/SidePanel.vue';
import EmailOnboardingProvider from 'vcomponents/email/EmailOnboardingProvider.vue';

export default {

    components: {
        SidePanel,
        EmailOnboardingProvider
    },
    props: {
        callback: {
            type: String,
            required: false
        }
    },
    methods: {
        close(){
            this.$emit('close')
        },
        /**
             * Redirect to onboardingEmail page with provider in param
             * 
             * @return {void}
             */
        onValidProvider(provider) {
            this.$router.push({name: 'onboarding.email', params: { provider, context: this.callback }})
            this.close();
        },
    }
}
</script>